import React from "react"
import {
    HolidayVillageOutlined,
    AdsClickOutlined,
} from "@mui/icons-material"
import {
    IconButton,
    Tooltip,
    Typography
} from "@mui/material"
import { makeStyles } from "@mui/styles"

const MONTHS = [
    "January", "February", "March", "April",
    "May", "June", "July", "August",
    "September", "October", "November", "December",
]

export default function MonthList() {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            {MONTHS.map((month, index) => (
                <div key={month} className={classes.itemWrapper}>
                    <HolidayVillageOutlined className={classes.icon} />

                    <Typography className={classes.itemText}>
                        {month}
                    </Typography>

                    <div style={{ flex: 1 }} />

                    <Tooltip title={`View ${month}`} arrow placement="bottom">
                        <IconButton size="small">
                            <AdsClickOutlined className={classes.icon} />
                        </IconButton>
                    </Tooltip>
                </div>
            ))}
        </div>
    )
}

const useStyles = makeStyles({
    root: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "6px",
    },
    itemWrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        minHeight: "40px",
        padding: "0 6px 0 12px",
        borderRadius: "10px",
        backgroundColor: "#f8fafc",
        border: "1px solid #f1f5f9",
    },
    itemText: {
        fontFamily: "inherit",
        fontWeight: 600,
        fontSize: "13px",
        color: "var(--text-primary)",
        marginLeft: "10px",
    },
    icon: {
        color: "var(--accent, var(--color-primary))",
        fontSize: "18px",
    },
    empty: {
        fontSize: "13px",
        color: "var(--text-light)",
        padding: "10px 12px",
        borderRadius: "10px",
        backgroundColor: "#f8fafc",
    },
})
